import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <h1 className="mt-6 font-heading text-3xl font-extrabold text-foreground-950 md:text-4xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面不存在或已被移除，返回首页继续发现热门短视频吧。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label text-background-50 transition-colors duration-200 hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-lg"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-label text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-search-line text-lg"></i>
          去搜索
        </Link>
      </div>
    </div>
  );
}